export default [
  {
    path: 'paychecks',
    name: 'employee_paycheck',
    component: () => import('./EmployeePaycheck.vue'),
    meta: {
      name: 'Contracheques',
      auth: true,
      user: 'Admin',
    },
  },
]
